module.exports = __webpack_public_path__ + "img//EUMOVE_2_1_3_3.svg";